import { render } from 'preact';
import { onConfigChange, setConfig } from '@/config';
import { setCookie } from '@/utils';
import Assistant from './components/Assistant';

if (process.env.NODE_ENV === 'development') {
	import('preact/debug');
}

function exitAssistant() {
	const confirmedExit = confirm('Are you sure you want to exit the Mopinion Deployment Assistant?');
	if (!confirmedExit) {
		return;
	}
	renderUI(true);
	setConfig(config => {
		config.debug = [];
	});
	setCookie('MOP_assistant', null);
}

function renderUI(exit) {
	if (!document.querySelector('[data-deploy-debug-type="target"]')) {
		const target = document.createElement('div');
		target.setAttribute('data-deploy-debug-type', 'target');
		document.body.appendChild(target);
	}

	render(exit ? null : <Assistant exit={exitAssistant} />, document.querySelector('[data-deploy-debug-type="target"]'));
}

function start() {
	onConfigChange(config => {
		setTimeout(() => {
			renderUI();
		});
	});
	renderUI();
}

export { start };
